import { render } from "./admin-sidebar.vue?vue&type=template&id=7dd15f54"
import script from "./admin-sidebar.vue?vue&type=script&lang=js"
export * from "./admin-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__